// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".template-renderer[data-v-72777b44] a,\n.template-renderer[data-v-72777b44] .link {\n  color: var(--theme-light, #008a61);\n}\n.template-renderer[data-v-72777b44] a:hover,\n.template-renderer[data-v-72777b44] .link:hover {\n  color: var(--theme, #00573d);\n}\n.template-renderer[data-v-72777b44] a:hover {\n  text-decoration: underline;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
